import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// SPA: React Router non resetta lo scroll al cambio pagina come farebbe
// una navigazione classica del browser, quindi la pagina nuova eredita
// la posizione di scroll di quella precedente. Reagisce solo al pathname
// (non a query string/hash) per non "saltare" quando cambiano solo i
// search params sulla stessa pagina (es. /dashboard?verified=1).
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
